import React, { Component } from 'react';
import { connect } from "react-redux";
import { Button, Tabs, Tab, Nav } from 'react-bootstrap';
import * as actionCreator from "../../../action/index.js";
import * as cuComponent from '../../../redux/reducers/building_component/componentReducer.js';
import { params } from '../../../redux/reducers/reducer.js';


class SnowLoad extends Component {
   render() {
      let newClass = "";
      newClass = this.props.const_var.noCursorClass == true ? 'no-cursor' : '';
      let textLabel = "Heavy Snow/Wind Load";
      if (params.p_s_n == "38" && (params.m_s_n == "11" || params.m_s_n == 54) && this.props.const_var.CheckSnowLoadFlag == true) {
         textLabel = (this.props.const_var.CheckSnowLoadValue == 35 || this.props.const_var.CheckSnowLoadValue == 65) ? "Yellow Book" : textLabel;
      }
      if (params.p_s_n == "5" && (params.m_s_n == "11" || params.m_s_n == 54) && this.props.const_var.CheckSnowLoadFlag == true) {
         textLabel = (this.props.const_var.CheckSnowLoadValue == 35 || this.props.const_var.CheckSnowLoadValue == 65) ? "Red Book" : textLabel;
      }
      if ((params.p_s_n=="29" || params.p_s_n=="35" || params.p_s_n=="37" || params.p_s_n=="40" || params.p_s_n=="9") && params.m_s_n == "122" && this.props.const_var.CheckSnowLoadFlag == true) {
         textLabel = (this.props.const_var.CheckSnowLoadValue == 35 || this.props.const_var.CheckSnowLoadValue == 65) ? "4ft On Center" : textLabel;
      }
      if ((params.p_s_n=="29" || params.p_s_n=="35" || params.p_s_n=="37" || params.p_s_n=="40" || params.p_s_n=="9") && params.m_s_n == "122" && this.props.const_var.CheckSnowLoadFlag == true) {
         textLabel = (this.props.const_var.CheckSnowLoadValue == 35 || this.props.const_var.CheckSnowLoadValue == 65) ? "4ft On Center" : textLabel;
      }
      return (
         <>

            <div className={newClass != '' ? 'toggle-group d-none' : "toggle-group"}>
               <div class={params.isSnowLoad == true ? "toggle-switches toggle-switch-md active" : "toggle-switches toggle-switch-md"}>
                  <span className='toggle-label-control'>{textLabel}</span>
                  <input id="snowWind" name="Heavy Snow/Wind Load" type="checkbox" checked={params.isSnowLoad == true ? true : false}/>
                  <label for="snowWind" onClick={() => { this.props.CheckSnowLoadBuilding() }}></label>
               </div>
            </div>

            {/* <div className={newClass != '' ? 'togglelabel d-none' : 'togglelabel'}>
               <div className={params.isSnowLoad == true ? "toggle-item active " + newClass : "toggle-item " + newClass}>
                  <span className='toggle-label'>{textLabel}</span> <span className='toggle-switch'> <input type="checkbox" id="backlean" />
                     <label for="backlean" className="cursor-pointer" onClick={() => { this.props.CheckSnowLoadBuilding() }}><i></i></label>
                  </span>
               </div>
            </div> */}
            <div className="snow-load-wrapper d-none">
               <Tab.Container defaultActiveKey="snowloadthirtyfive">
                  <Nav variant="pills">
                     <Nav.Item>
                        <Nav.Link eventKey="snowloadthirtyfive" onClick={() => this.props.CheckSnowLoadBuilding(35)}>
                           Normal Snow/Wind Load
                        </Nav.Link>
                     </Nav.Item>
                     <Nav.Item>
                        <Nav.Link eventKey="snowloadsixtyfive" onClick={() => this.props.CheckSnowLoadBuilding(65)}>
                           Heavy Snow/Wind Load
                        </Nav.Link>
                     </Nav.Item>
                  </Nav>
               </Tab.Container>
            </div>
         </>
      );


   }
}




const mapStoreToProps = (state) => {
   return state.reducer
}


export default connect(
   mapStoreToProps,
   actionCreator
)(SnowLoad);